import { Injectable } from "@angular/core";
import { io as socketIo } from "socket.io-client";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class SocketService {
  public socket;
  public SERVER_URL = environment.baseUrl.replace("/api/", "");

  public initSocket(): void {
    this.socket = socketIo(this.SERVER_URL, {
      query: { accessToken: JSON.parse(localStorage.userData).accessToken },
    });
  }


  public emitEvent(action, data) {
    this.socket.emit(action, data);
  }

  public onEvent(action) {
    return new Observable<any>((observer) => {
      this.socket.on(action, (data) => observer.next(data));
    });
  }
}
